import { AppLocale, fallbackLocale, hasLocale, localeCookieName } from './locales';
import enMessages from '../../messages/en.json';
import ptBRMessages from '../../messages/pt-BR.json';

const messagesByLocale = {
  en: enMessages,
  'pt-BR': ptBRMessages,
} as const;

export function getMessagesSync(locale: AppLocale) {
  return messagesByLocale[locale];
}

export function getLocaleFromCookieSync(): AppLocale {
  if (typeof document === 'undefined') {
    return fallbackLocale;
  }

  const cookie = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${localeCookieName}=`));

  if (!cookie) {
    return fallbackLocale;
  }

  const value = decodeURIComponent(cookie.split('=').slice(1).join('='));

  if (hasLocale(value)) {
    return value;
  }

  return fallbackLocale;
}
